import {AppLoginSubjectExtension} from './app-login-subject-ext.model';

export class RegistrationRequestDtoModel {
  email: string;
  nameFirst?: string;
  nameLast?: string;
  dob?: Date;
  password: string;
  description: string;
  domain: string;
  mobileNumber: string;
  messageTemplate?: string;
  pinNumber?: string;
  hostName?: string;
  referralCode?: string;
  user_agreement_consent_guids?: string[];

  appLoginSubjectExtList?: AppLoginSubjectExtension[];

  constructor() {
    this.appLoginSubjectExtList = [];
  }

  withSystemDefaultFirstNameExtension(fname: string) {
    let firstNameExt = new AppLoginSubjectExtension();
    firstNameExt.status = 'ACTIVE';
    firstNameExt.param_code = AppLoginSubjectExtension.ParamCode.FIRST_NAME;
    firstNameExt.param_name = 'FIRST_NAME';
    firstNameExt.param_type = 'String';
    firstNameExt.value_string = fname;
    firstNameExt.ext_type = AppLoginSubjectExtension.ExtType.SYSTEM_DEFAULT;
    firstNameExt.ext_code = AppLoginSubjectExtension.ExtCode.OPTIONAL_PARAM;
    this.appLoginSubjectExtList.push(firstNameExt);
    return this;
  }

  withSystemDefaultLastNameExtension(lname: string) {
    let lastNameExt = new AppLoginSubjectExtension();
    lastNameExt.status = 'ACTIVE';
    lastNameExt.param_code = AppLoginSubjectExtension.ParamCode.LAST_NAME;
    lastNameExt.param_name = 'LAST_NAME';
    lastNameExt.param_type = 'String';
    lastNameExt.value_string = lname;
    lastNameExt.ext_type = AppLoginSubjectExtension.ExtType.SYSTEM_DEFAULT;
    lastNameExt.ext_code = AppLoginSubjectExtension.ExtCode.OPTIONAL_PARAM;
    this.appLoginSubjectExtList.push(lastNameExt);
    return this;
  }
}


